// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2H4Lu","label":"Radio_label__1o2pE","checkMark":"Radio_checkMark__1Fxnx","disabled":"Radio_disabled__1kiox"};